// Будут отдельно подключаться и в теории должны быть подключены до основных стилей приложения
// todo проверить
import normalize from 'normalize.css';


import swiperCss from 'swiper/dist/css/swiper.min.css';
import '@fancyapps/fancybox/dist/jquery.fancybox.min.css';

window.$ = window.jQuery = require('jquery');
window.moment = require('moment');

window.Swiper = require('swiper/dist/js/swiper.min.js');
window.fancybox = require('@fancyapps/fancybox/dist/jquery.fancybox.min.js');

import Vue from 'vue';
import VueResource from 'vue-resource';
import App from './App.vue';
import router from './router';
import './registerServiceWorker';


Vue.use(VueResource);

Vue.config.productionTip = false;

new Vue({
  router,
  render: h => h(App)
}).$mount('#app');
